import type { AxiosError } from "axios";
import { useState } from "react";
import { useGlobalStore } from "../../contexts/globalStoreContext";
import { api } from "../../services";
import type { BalanceInquiryRequestErrorEnum} from "../../services/APIService/types";
import { BalanceInquiryRequestStatusEnum } from "../../services/APIService/types";

interface GetFetchBalance {
	onSuccess(): Promise<void>;
	onFailed(statusError: BalanceInquiryRequestErrorEnum): void;
}

export const useFetchBalance = () => {
	const { authenticationStore: authStore } = useGlobalStore();
	const [load, isLoad] = useState(false);

	const postFetchBalance = async () => {
		if (load) {
			return;
		}

		isLoad(true);

		try {
			const balance = await api.postBalanceInquiryRequest(authStore.getToken() || "");
			return balance;
		} catch (error) {
			console.error(error);

			return;
		} finally {
			isLoad(false);
		}
	};

	const getFetchBalance = async ({onFailed, onSuccess}: GetFetchBalance) => {
		if (load) {
			return;
		}

		isLoad(true);

		try {
			const balance = await api.getBalanceInquiryRequest(authStore.getToken() || "");

			if (balance.status === BalanceInquiryRequestStatusEnum.failed && balance.error) {
				return onFailed(balance.error.errorEnumerator);
			}

			if (balance.status === BalanceInquiryRequestStatusEnum.success) {
				return onSuccess();
			}
		} catch (error) {
			isLoad(false);
			console.error(error);
			const err = error as AxiosError;

			if (err.status === 404) {
				// Chama a rota para criar o balance
				await api.postBalanceInquiryRequest(authStore.getToken() || "");
				return;
			}

			return;
		} finally {
			isLoad(false);
		}
	};

	return { getFetchBalance, postFetchBalance, load };
};
